import { Box } from '@mui/material';
import { FC, ReactNode } from 'react';

import { ReactComponent as CheckIcon } from 'src/assets/svg/check.svg';

import { styles } from './styles';

export const DiscountBanner: FC<{ children: ReactNode; id?: string }> = ({ children, id }) => (
    <Box css={styles.container} {...(id && { id })}>
        <CheckIcon />
        {children}
    </Box>
);
